import React from "react";
import {
  Facebook,
  Instagram,
  Phone,
  MapPin,
  Mail,
  Twitter,
} from "lucide-react";
import { Link } from "react-router-dom";
import FooterImage from "../assets/FooterImage.png";
import logo from "../assets/logo.png";

export function Footer() {
  return (
    <footer className="relative bg-gradient-to-r from-gray-900 to-gray-700 text-white">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 opacity-20 hidden lg:block"
        style={{
          backgroundImage: `url(${FooterImage})`,
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 w-full lg:w-[70%]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Column - Main Branch and Quick Links */}
          <div className="flex flex-col sm:flex-row justify-between gap-8 sm:gap-5">
            {/* Main Branch Info */}
            <div className="flex flex-col items-start">
              <h3 className="text-red-400 font-semibold mb-4 sm:mb-6">
                Main Branch
              </h3>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center gap-2">
                  <MapPin className="w-5 h-5" />
                  <p className="text-xs sm:text-sm">
                    1 N Division St.
                    <br />
                    Selma, AL 36703
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Phone className="w-5 h-5" />
                  <p className="text-xs sm:text-sm">615.944.6168</p>
                </div>
                <div className="flex items-center gap-2">
                  <Mail className="w-5 h-5" />
                  <p className="text-xs sm:text-sm">info@SilverTLC.com</p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="flex flex-col items-start sm:items-end md:items-start">
              <h3 className="text-red-400 font-semibold mb-4 sm:mb-6">
                Quick Links
              </h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="hover:text-red-400">
                  <Link to="/about" className="text-xs sm:text-sm">
                    About Us
                  </Link>
                </li>
                <li className="hover:text-red-400">
                  <Link to="/register" className="text-xs sm:text-sm">
                    Register | Sign-In
                  </Link>
                </li>
                <li className="hover:text-red-400">
                  <Link to="/donate" className="text-xs sm:text-sm">
                    Donate
                  </Link>
                </li>
                <li className="hover:text-red-400">
                  <Link className="text-xs sm:text-sm">Chat</Link>
                </li>
                <li className="hover:text-red-400">
                  <Link to="/contact" className="text-xs sm:text-sm">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column - Logo and Social */}
          <div className="flex flex-col items-center md:items-start lg:ml-16 xl:ml-36 mt-0 md:mt-0">
            <div className="flex flex-col items-center md:items-start">
              {/* Logo and Name */}
              <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 mb-4">
                <img
                  src={logo}
                  alt="SilverTLC"
                  className="w-40 sm:w-52 h-auto"
                />
                <span className="text-2xl sm:text-3xl font-extrabold tracking-wide">
                  SilverTLC
                </span>
              </div>

              {/* Social Icons */}
              <div className="flex gap-4 px-9 sm:gap-6 mt-2 sm:mt-4">
                <Link to="#" className="hover:text-red-400">
                  <Instagram className="w-5 h-5 sm:w-6 sm:h-6" />
                </Link>
                <Link to="#" className="hover:text-red-400">
                  <Facebook className="w-5 h-5 sm:w-6 sm:h-6" />
                </Link>
                <Link to="#" className="hover:text-red-400">
                  <Twitter className="w-5 h-5 sm:w-6 sm:h-6" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-800">
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-4 md:mb-0">
            <Link
              to="/privacy"
              className="text-xs sm:text-sm hover:text-red-400"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-600 hidden sm:inline">|</span>
            <Link to="/terms" className="text-xs sm:text-sm hover:text-red-400">
              Terms & Conditions
            </Link>
          </div>
          <p className="text-xs sm:text-sm text-gray-400 text-center md:text-right">
            Copyright © 2024. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
